export const urlWhatsApp = 'https://api.whatsapp.com/send?phone=';
export const IOS_ID = 'https://apps.apple.com/cr/app/passer-technologies/id1494258458';
export const ANDROID_ID = 'https://play.google.com/store/apps/details?id=passer.app';
export const TYPE_ID_SYSTEM = 'DMN';
export const API_KEY_MAPS = 'AIzaSyAaQclndPTJ6cKQIZyaVLT-z49Xzdgl8a4';
export const openAccountLink = 'https://cuentasces.bnenlinea.com/BNCR.CES.WEB/CrearCliente/IdentificacionCliente.aspx';
export const supportLink = 'https://passer.atlassian.net/servicedesk/customer/portal/4';
export const openReplayKey = 'CiNoZccI8HsnxynEQ8j3';